/**
 * Bundle & Seal Subscriptions Sync Script
 * Controls visibility and selection of subscription options
 */

(function() {
  'use strict';

  console.log('[Bundle-Seal Sync] ========================================');
  console.log('[Bundle-Seal Sync] Script loaded at:', new Date().toLocaleTimeString());
  console.log('[Bundle-Seal Sync] Page URL:', window.location.href);
  console.log('[Bundle-Seal Sync] ========================================');

  let isInitialized = false;
  let observer = null;
  let styleElement = null;

  /**
   * Initialize the script
   */
  function init() {
    if (isInitialized) {
      console.log('[Bundle-Seal Sync] Already initialized, skipping...');
      return;
    }

    console.log('[Bundle-Seal Sync] Initializing...');
    
    // Create style element for CSS
    createStyleElement();
    
    // Try immediate check first
    if (checkAndSetup()) {
      return;
    }

    // If not found, use MutationObserver to watch for elements
    console.log('[Bundle-Seal Sync] Elements not found yet, watching for DOM changes...');
    startObserving();
    
    // Also use interval as backup (more reliable for some cases)
    startIntervalCheck();
  }

  /**
   * Create style element for dynamic CSS
   */
  function createStyleElement() {
    styleElement = document.createElement('style');
    styleElement.id = 'bundle-seal-sync-styles';
    document.head.appendChild(styleElement);
    console.log('[Bundle-Seal Sync] ✓ Style element created');
  }

  /**
   * Check if elements exist and set up if they do
   */
  function checkAndSetup() {
    const bundleContainer = document.querySelector('.bndlr-radio-container');
    const sealContainer = document.querySelector('.sealsubs-target-element');
    const subscriptionCheckbox = document.querySelector('.bndlr-subscription-checkbox');

    if (bundleContainer && sealContainer && subscriptionCheckbox) {
      console.log('[Bundle-Seal Sync] ========================================');
      console.log('[Bundle-Seal Sync] ✓✓✓ SUCCESS! All required elements found!');
      console.log('[Bundle-Seal Sync] ========================================');
      
      // Stop observing
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      
      isInitialized = true;
      setupListeners();
      updateDisplay();
      
      console.log('[Bundle-Seal Sync] ✓✓✓ SCRIPT FULLY INITIALIZED AND RUNNING!');
      return true;
    }

    return false;
  }

  /**
   * Start observing DOM changes
   */
  function startObserving() {
    observer = new MutationObserver(function(mutations) {
      // Check if our elements now exist
      if (checkAndSetup()) {
        console.log('[Bundle-Seal Sync] Elements detected via MutationObserver!');
      }
    });

    // Start observing the document body for child additions
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    console.log('[Bundle-Seal Sync] MutationObserver started');
  }

  /**
   * Start interval check as backup
   */
  function startIntervalCheck() {
    let attempts = 0;
    const maxAttempts = 60; // 30 seconds total
    
    const checkInterval = setInterval(function() {
      attempts++;

      if (isInitialized) {
        clearInterval(checkInterval);
        return;
      }

      const bundleContainer = document.querySelector('.bndlr-radio-container');
      const sealContainer = document.querySelector('.sealsubs-target-element');
      const subscriptionCheckbox = document.querySelector('.bndlr-subscription-checkbox');

      // Log every 10 attempts (5 seconds)
      if (attempts % 10 === 0) {
        console.log('[Bundle-Seal Sync] Attempt', attempts + '/' + maxAttempts);
        console.log('  - Bundle container:', bundleContainer ? '✓' : '✗');
        console.log('  - Seal container:', sealContainer ? '✓' : '✗');
        console.log('  - Subscription checkbox:', subscriptionCheckbox ? '✓' : '✗');
      }

      if (checkAndSetup()) {
        clearInterval(checkInterval);
        console.log('[Bundle-Seal Sync] Elements found via interval check!');
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.error('[Bundle-Seal Sync] ✗✗✗ TIMEOUT after', maxAttempts, 'attempts');
        
        // Diagnostic info
        const allBundlerElements = document.querySelectorAll('[class*="bndlr"]');
        const allSealElements = document.querySelectorAll('[class*="seal"]');
        console.log('[Bundle-Seal Sync] Diagnostic:');
        console.log('  - Elements with "bndlr":', allBundlerElements.length);
        console.log('  - Elements with "seal":', allSealElements.length);
        
        if (allBundlerElements.length > 0) {
          console.log('  - Sample bundler classes:', allBundlerElements[0].className);
        }
        if (allSealElements.length > 0) {
          console.log('  - Sample seal classes:', allSealElements[0].className);
        }
      }
    }, 500);
  }

  /**
   * Set up event listeners
   */
  function setupListeners() {
    console.log('[Bundle-Seal Sync] Setting up event listeners...');
    
    // Listen for bundle quantity changes
    document.addEventListener('change', function(e) {
      if (e.target.name === 'bundle_quantity') {
        console.log('[Bundle-Seal Sync] 📦 Bundle changed to:', e.target.value);
        setTimeout(updateDisplay, 100);
      }
      
      // Listen for subscription checkbox changes
      if (e.target.classList.contains('bndlr-subscription-checkbox')) {
        console.log('[Bundle-Seal Sync] ✓ Subscription checkbox changed:', e.target.checked);
        setTimeout(updateDisplay, 100);
      }

      // Listen for Seal subscription option changes
      if (e.target.classList.contains('sls-option')) {
        console.log('[Bundle-Seal Sync] 🔘 Seal option changed to:', e.target.value);
        setTimeout(updateDisplay, 100);
      }
    }, true);

    // Also listen for clicks on bundle containers
    const bundleContainers = document.querySelectorAll('.bndlr-radio-container');
    bundleContainers.forEach(function(container) {
      container.addEventListener('click', function() {
        setTimeout(updateDisplay, 100);
      });
    });
    
    console.log('[Bundle-Seal Sync] ✓ Event listeners attached');
  }

  /**
   * Main update function
   */
  function updateDisplay() {
    const selectedBundle = getSelectedBundle();
    const isSubscribed = isSubscriptionChecked();
    
    console.log('[Bundle-Seal Sync] ========================================');
    console.log('[Bundle-Seal Sync] 🔄 UPDATE TRIGGERED');
    console.log('[Bundle-Seal Sync] Selected Bundle:', selectedBundle);
    console.log('[Bundle-Seal Sync] Is Subscribed:', isSubscribed);
    console.log('[Bundle-Seal Sync] ========================================');

    if (!selectedBundle) {
      console.warn('[Bundle-Seal Sync] ⚠ No bundle selected, skipping update');
      return;
    }

    // Update bundle price visibility
    updateBundlePriceVisibility();
    
    // Update subscription visibility and options
    updateSubscriptionSection(selectedBundle);
  }

  /**
   * Update bundle price visibility - only show selected bundle price
   */
  function updateBundlePriceVisibility() {
    const css = `
      /* Hide all bundle prices by default */
      .bndlr-radio-container .bndlr-price {
        display: none !important;
      }
      
      /* Show only the selected bundle price */
      .bndlr-radio-container input[name="bundle_quantity"]:checked + label .bndlr-price {
        display: block !important;
      }
    `;

    styleElement.textContent = css;
    console.log('[Bundle-Seal Sync] ✓ Price visibility updated - only selected bundle price shown');
  }

  /**
   * Get currently selected bundle
   */
  function getSelectedBundle() {
    const checkedRadio = document.querySelector('input[name="bundle_quantity"]:checked');
    if (!checkedRadio) {
      return null;
    }

    const value = checkedRadio.value;
    
    if (value === '1') return 'one-month';
    if (value === '3') return 'three-month';
    if (value === '6') return 'six-month';
    return null;
  }

  /**
   * Check if subscription is enabled
   */
  function isSubscriptionChecked() {
    const checkbox = document.querySelector('.bndlr-subscription-checkbox');
    return checkbox ? checkbox.checked : false;
  }

  /**
   * Update subscription section visibility and options
   */
  function updateSubscriptionSection(selectedBundle) {
    const subscriptionContainer = document.querySelector('.bndlr-subscription-container');
    const subscriptionCheckbox = document.querySelector('.bndlr-subscription-checkbox');
    const sealOptions = document.querySelectorAll('.sls-option-container');

    if (!subscriptionContainer) {
      console.error('[Bundle-Seal Sync] ✗ Subscription container not found!');
      return;
    }

    // Rule 1: One Month - Hide subscription completely
    if (selectedBundle === 'one-month') {
      subscriptionContainer.style.display = 'none';
      if (subscriptionCheckbox) {
        subscriptionCheckbox.checked = false;
        subscriptionCheckbox.disabled = true;
      }
      
      // Hide all seal options except one-time
      sealOptions.forEach(function(option) {
        const radio = option.querySelector('.sls-option');
        if (radio && radio.value === 'one_time') {
          option.style.display = 'block';
          if (!radio.checked) {
            radio.click();
          }
        } else {
          option.style.display = 'none';
        }
      });
      
      console.log('[Bundle-Seal Sync] ✓ 1-MONTH: Hidden subscription section');
      return;
    }

    // Show subscription container for 3 and 6 month
    subscriptionContainer.style.display = 'block';
    if (subscriptionCheckbox) {
      subscriptionCheckbox.disabled = false;
    }

    // Get subscription options
    const oneTimeOption = getOptionByValue(sealOptions, 'one_time');
    const threeMonthOption = getOptionBySellingPlanGroup(sealOptions, '0');
    const sixMonthOption = getOptionBySellingPlanGroup(sealOptions, '1');

    console.log('[Bundle-Seal Sync] Found options:');
    console.log('  - One-time:', oneTimeOption ? '✓' : '✗');
    console.log('  - 3-month (group=0):', threeMonthOption ? '✓' : '✗');
    console.log('  - 6-month (group=1):', sixMonthOption ? '✓' : '✗');
    
    if (threeMonthOption) {
      console.log('  - 3-month label:', threeMonthOption.querySelector('.sls-selling-plan-group-name')?.textContent);
    }
    if (sixMonthOption) {
      console.log('  - 6-month label:', sixMonthOption.querySelector('.sls-selling-plan-group-name')?.textContent);
    }

    // Rule 2: Three Month - Show only one-time and 3-month subscription
    if (selectedBundle === 'three-month') {
      if (oneTimeOption) oneTimeOption.style.display = 'block';
      if (threeMonthOption) threeMonthOption.style.display = 'block';
      if (sixMonthOption) sixMonthOption.style.display = 'none';
      
      // Auto-select based on checkbox state
      if (subscriptionCheckbox && subscriptionCheckbox.checked && threeMonthOption) {
        selectSealOption(threeMonthOption);
        console.log('[Bundle-Seal Sync] ✓ 3-MONTH: Auto-selected 3-month subscription');
      } else if (oneTimeOption) {
        selectSealOption(oneTimeOption);
        console.log('[Bundle-Seal Sync] ✓ 3-MONTH: Auto-selected one-time');
      }
    }

    // Rule 3: Six Month - Show only one-time and 6-month subscription
    if (selectedBundle === 'six-month') {
      if (oneTimeOption) oneTimeOption.style.display = 'block';
      if (threeMonthOption) threeMonthOption.style.display = 'none';
      if (sixMonthOption) sixMonthOption.style.display = 'block';
      
      // Auto-select based on checkbox state
      if (subscriptionCheckbox && subscriptionCheckbox.checked && sixMonthOption) {
        selectSealOption(sixMonthOption);
        console.log('[Bundle-Seal Sync] ✓ 6-MONTH: Auto-selected 6-month subscription');
      } else if (oneTimeOption) {
        selectSealOption(oneTimeOption);
        console.log('[Bundle-Seal Sync] ✓ 6-MONTH: Auto-selected one-time');
      }
    }
  }

  /**
   * Get option by value attribute
   */
  function getOptionByValue(options, value) {
    for (let i = 0; i < options.length; i++) {
      const radio = options[i].querySelector('.sls-option');
      if (radio && radio.value === value) {
        return options[i];
      }
    }
    return null;
  }

  /**
   * Get option by selling plan group data attribute
   */
  function getOptionBySellingPlanGroup(options, groupId) {
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      if (option.getAttribute('data-selling-plan-group') === groupId) {
        return option;
      }
    }
    return null;
  }

  /**
   * Select a specific Seal subscription option
   */
  // function selectSealOption(optionContainer) {
  //   const radio = optionContainer.querySelector('input[type="radio"].sls-option');
  //   if (!radio) {
  //     console.error('[Bundle-Seal Sync] ✗ No radio button found in option container');
  //     return;
  //   }
    
  //   // Get the selling plan ID from the select dropdown in this option
  //   const selectElement = optionContainer.querySelector('select.sls-select');
  //   const selectedOption = selectElement ? selectElement.options[selectElement.selectedIndex] : null;
  //   const sellingPlanId = selectedOption ? selectedOption.value : null;
    
  //   console.log('[Bundle-Seal Sync] Selecting option:', {
  //     value: radio.value,
  //     name: radio.name,
  //     sellingPlanGroup: optionContainer.getAttribute('data-selling-plan-group'),
  //     label: optionContainer.querySelector('.sls-selling-plan-group-name')?.textContent,
  //     sellingPlanId: sellingPlanId
  //   });
    
  //   if (!radio.checked) {
  //     radio.click();
      
  //     // Wait for click to process
  //     setTimeout(function() {
  //       // Update the hidden selling_plan input field
  //       const sealContainer = document.querySelector('.sealsubs-target-element');
  //       const hiddenSellingPlanInput = sealContainer ? sealContainer.querySelector('input[name="selling_plan"]') : null;
        
  //       if (hiddenSellingPlanInput && sellingPlanId) {
  //         hiddenSellingPlanInput.value = sellingPlanId;
  //         console.log('[Bundle-Seal Sync] ✓ Updated hidden selling_plan input to:', sellingPlanId);
  //       }
        
  //       if (radio.checked) {
  //         console.log('[Bundle-Seal Sync] ✓ Option successfully selected and verified');
  //       } else {
  //         console.error('[Bundle-Seal Sync] ✗ Option selection failed - radio not checked!');
  //       }
  //     }, 100);
  //   } else {
  //     console.log('[Bundle-Seal Sync] ℹ Option already selected');
  //   }
  // }

  // 15 11 25 mk
  /**
 * Select a specific Seal subscription option
 */
function selectSealOption(optionContainer) {
  // Click the visible label container instead of the radio button
  const clickTarget = optionContainer.querySelector('.sls-selling-plan-group-first-line');
  
  if (clickTarget) {
    clickTarget.click();
    console.log('[Bundle-Seal Sync] ✓ Option selected');
  }
}


  // Start initialization with multiple strategies
  function startInit() {
    console.log('[Bundle-Seal Sync] Starting initialization...');
    
    // Try immediately
    init();
    
    // Try after a short delay (for fast-loading async content)
    setTimeout(function() {
      if (!isInitialized) {
        console.log('[Bundle-Seal Sync] Retry after 1 second...');
        init();
      }
    }, 1000);
    
    // Try after longer delay (for slow-loading async content)
    setTimeout(function() {
      if (!isInitialized) {
        console.log('[Bundle-Seal Sync] Retry after 3 seconds...');
        init();
      }
    }, 3000);
  }

  // Initialize based on document state
  if (document.readyState === 'loading') {
    console.log('[Bundle-Seal Sync] Document loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', startInit);
  } else {
    console.log('[Bundle-Seal Sync] Document already loaded, starting...');
    startInit();
  }

  // Also try on window.load (when everything including images is loaded)
  window.addEventListener('load', function() {
    if (!isInitialized) {
      console.log('[Bundle-Seal Sync] Window loaded, trying again...');
      init();
    }
  });

  // Reinitialize on Shopify section reload (for theme editor)
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function() {
      console.log('[Bundle-Seal Sync] Shopify section reloaded, reinitializing...');
      isInitialized = false;
      init();
    });
  }

})();